<template>
  <div class="home background">
    <BgVideo />
    <Topicos />
  </div>
</template>

<script>
import BgVideo from "./components/BgVideo.vue";
import Topicos from "./components/Topicos.vue";

export default {
  name: "Home",
  components: { BgVideo, Topicos },

  methods: {
  },
};
</script>

<style scoped></style>
